// @ts-nocheck

import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createReducer } from 'Helpers/redux'

import {
  GET_CAMPAIGN_TIKTOK_VIDEOS,
  GET_EVENT_BY_ID,
  GET_EVENTS_STATISTICS,
  GET_OFFERED_CAMPAIGNS,
  OPEN_CAMPAIGN_DETAILS,
  GET_EVENTS_IN_PROGRESS,
  GET_EVENTS_AWAITING_REVIEW,
  GET_EVENTS_COMPLETED,
  GET_EVENTS_CANCELED,
  SET_EVENT_DETAILS,
  SET_ID,
} from 'Redux/actions/influencerActions'

interface Profile {
  tiktokId: string
  shortId: string
  uniqueId: string
  nickname: string
  avatar: string
  createTime: string
  followerCount: number
  followingCount: number
  heartCount: number
  videoCount: number
}

export enum InfluencerCampaignStatus {
  AWAITING_REVIEW = 'awaiting_review',
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  RUNNING = 'running',
  IN_PROCESS = 'in_process',
  ENDED = 'ended',
  CANCELED = 'canceled',
  FINISHED = 'finished',
  STOPPED = 'stopped',
}

export enum InfluencerEventStatus {
  ACCEPTED = 'accepted',
  AWAITING_REVIEW = 'awaiting_review',
  AWAITING_MODERATOR_REVIEW = 'awaiting_moderator_review',
  APPROVED_BY_ARTIST = 'approved_by_artist',
  APPROVED_AUTOMATICALLY = 'approved_automatically',
  APPROVED_BY_ADMIN = 'approved_by_admin',
  CANCELED_BY_ARTIST = 'canceled_by_artist',
  DECLINED = 'declined',
  CANCELED = 'canceled',
}

export type InfluencerCampaigns =
  | InfluencerCampaign
  | InfluencerCampaignsInProgress
  | InfluencerCampaignsAwaitingreview
  | InfluencerCampaignsCompleted
  | InfluencerCampaignsCanceled
export interface InfluencerCampaign {
  id: number
  createdAt: string
  updatedAt: string
  trackTiktokId?: string
  startDate?: string
  deadlineToAccept?: string
  isDanceRequested?: boolean
  comment?: string
  trackTitle: string
  trackPlayUrl?: string
  trackCoverUrl?: string
  trackAuthorName: string
  trackUrl?: string
  trackDuration?: number
  genres?: string[]
  languages?: string[]
  status: InfluencerCampaignStatus | InfluencerEventStatus
  reward?: number
  paymentWillBeReceived?: string
  stars?: number
  deadlineToLoadVideo?: string
  isPaymentReceived?: boolean
  campaignArtistComment?: string
}

export interface InfluencerCampaignsInProgress {
  id: number
  createdAt: string
  updatedAt: string
  trackTitle: string
  trackCoverUrl: string
  trackAuthorName: string
  status: InfluencerCampaignStatus
  deadlineToLoadVideo: string
}

export interface InfluencerCampaignsAwaitingreview {
  id: number
  createdAt: string
  updatedAt: string
  trackTitle: string
  trackCoverUrl: string
  trackAuthorName: string
  status: InfluencerCampaignStatus
  videoUploadDate?: string
}

export interface InfluencerCampaignsCompleted {
  id: number
  createdAt: string
  updatedAt: string
  trackTitle: string
  trackCoverUrl: string
  trackAuthorName: string
  status: InfluencerCampaignStatus
  reward?: number
  stars?: number
  paymentWillBeReceived?: string
}

export interface InfluencerCampaignsCanceled {
  id: number
  createdAt: string
  updatedAt: string
  trackTitle: string
  trackCoverUrl: string
  trackAuthorName: string
  status: InfluencerCampaignStatus
}

interface Pagination {
  pageNumber: number
  pageSize: number
  itemCount: number
  pageCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface Event {
  id: number
  createdAt: string
  updatedAt: string
  status: string
  tiktokCampaignId: number
  videoLink: string
  videoUploadDate: string
  nickname: string
  avatar: string
  rate: number
  uniqueId: string
  followerCount: number
  influencerTiktokProfileLink: string
  feedback: string
}
export interface EventDetails {
  reward: number
  status: InfluencerEventStatus
  stars: number
  genres: string[]
  languages: string[]
  trackTitle: string
  trackPlayUrl: string
  trackCoverUrl: string
  trackAuthorName: string
  trackDuration: number
  trackUrl: string
  comment: string
  isDanceRequested: boolean
  campaignArtistComment: string
  feedback?: string
  videoLink?: string
  tiktokVideoUrl?: string
}

export interface CampainVideo {
  createdAt: string
  feedback: string
  followerCount: number
  id: number
  nickname: string
  stars: number
  status: string
  tiktokCampaignId: number
  updatedAt: string
  videoLink: string
  videoUploadDate: string
  reward?: number
}

export type CampainVideos = Array<CampainVideo>
type CampaignId = string

export type Events = Record<CampaignId, CampainVideo[]>

export interface InfluencerState {
  profile: Profile | Record<string, never>
  campaigns: InfluencerCampaign[]
  campaignsInProgress: InfluencerCampaignsInProgress[]
  campaignsAwaitingReview: InfluencerCampaignsAwaitingreview[]
  campaignsCompleted: InfluencerCampaignsCompleted[]
  campaignsCanceled: InfluencerCampaignsCanceled[]
  campaignsPagination: Pagination
  eventStatistics: {
    newTracks: number
    inProgress: number
    awaitingReview: number
    completed: number
    canceled: number
  }
  eventDetails?: EventDetails

  events: Events | Record<string, never>
  openedCampaignId: number
  videos: CampainVideo[]
  token: string
  eventDetailsId: number
}

const initialState: InfluencerState = {
  profile: {},
  campaigns: [],
  campaignsPagination: {
    pageNumber: 0,
    pageSize: 0,
    itemCount: 0,
    pageCount: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
  eventStatistics: {
    awaitingReview: 0,
    newTracks: 0,
    canceled: 0,
    inProgress: 0,
    completed: 0,
  },
  campaignsInProgress: [],
  campaignsAwaitingReview: [],
  campaignsCompleted: [],
  campaignsCanceled: [],
  events: {},
  openedCampaignId: 0,
  videos: [],
  token: '',
  eventDetailsId: null,
}

const persistConfig = {
  key: 'influencer',
  storage,
  blacklist: ['error'],
}

const handlers = {
  [GET_OFFERED_CAMPAIGNS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaigns: payload.data,
    campaignsPagination: payload.meta,
  }),
  [GET_EVENTS_STATISTICS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    eventStatistics: payload,
  }),
  [OPEN_CAMPAIGN_DETAILS]: (prevState, { payload }) => ({
    ...prevState,
    openedCampaignId: payload,
  }),

  [GET_CAMPAIGN_TIKTOK_VIDEOS.SUCCESS]: (prevState, { payload }) => ({
    videos: [...payload.data],
  }),

  [GET_EVENTS_IN_PROGRESS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaignsInProgress: payload.data,
    campaignsPagination: payload.meta,
  }),
  [GET_EVENTS_AWAITING_REVIEW.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaignsAwaitingReview: payload.data,
    campaignsPagination: payload.meta,
  }),
  [GET_EVENTS_COMPLETED.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaignsCompleted: payload.data,
    campaignsPagination: payload.meta,
  }),
  [GET_EVENTS_CANCELED.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    campaignsCanceled: payload.data,
    campaignsPagination: payload.meta,
  }),
  [GET_EVENT_BY_ID.SUCCESS]: (prevState: InfluencerState, { payload }) => ({
    ...prevState,
    eventDetails: payload,
  }),
  [SET_EVENT_DETAILS]: (prevState: InfluencerState, { payload }) => ({
    ...prevState,
    eventDetails: payload,
  }),
  [SET_ID]: (prevState, { payload }) => ({
    ...prevState,
    eventDetailsId: payload,
  }),
}

export default persistReducer(
  persistConfig,
  createReducer(initialState, handlers)
)
